var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      !_vm.irrigacao.possuiIrrigacao
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label:
                        "Possui sistemas irrigados ou sistema fertirrigação?",
                      content: "Não"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label:
                        "Possui sistemas irrigados ou sistema fertirrigação?",
                      content: "Sim"
                    }
                  }),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "Área irrigada (em hectares):",
                      content: _vm.irrigacao.area
                    }
                  }),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "Data de início da irrigação (mês/ano):",
                      content: _vm.formataStringYearMonthToBr(
                        _vm.irrigacao.dataInicio
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "Tipo de sistema:",
                      content: _vm.formataTiposSistemas(
                        _vm.irrigacao.tiposSistemas
                      )
                    }
                  }),
                  _vm._v(" "),
                  _vm.irrigacao.tiposSistemas.length &&
                  _vm.irrigacao.tiposSistemas.includes("OUTRO")
                    ? _c("app-display", {
                        attrs: {
                          label: "Outros tipo de sistema:",
                          content: _vm.irrigacao.outroSistema
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Fonte de água utilizada:",
                      content: _vm.formataFontesAgua(_vm.irrigacao.fontesAgua)
                    }
                  }),
                  _vm._v(" "),
                  _vm.irrigacao.fontesAgua.length &&
                  _vm.irrigacao.fontesAgua.includes("OUTRO")
                    ? _c("app-display", {
                        attrs: {
                          label: "Outras fonte de água:",
                          content: _vm.irrigacao.outroFonteAgua
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "Captação licenciada?",
                      content: _vm.formataCaptacaoLicenciada(
                        _vm.irrigacao.captacaoLicenciada
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("app-display", {
                    attrs: {
                      label: "Qual a quantidade de água anual utilizada?",
                      content: _vm.irrigacao.quantidadeAguaAnual + " m³"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2" }, [
      _c("span", { staticClass: "title-praticas" }, [
        _vm._v("Dados da irrigação")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ed7e240", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ed7e240","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/components/Irrigacao.vue
// module id = null
// module chunks = 